import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root',
})

export class LoginGuardService implements CanActivate {
  constructor(private router: Router,
    private appSettingsService: AppSettingsService,
  ) {}
  
  canActivate(): boolean {
    if (this.appSettingsService.getLoginOnLocalhost() === "true") {
      return true;
    } else {
      window.location.href = this.appSettingsService.getHiperstream3();
      return false;
    }
  }
}
